import { DropdownOption } from '@keplerco/core';
import { Entity } from '../../models';

export function generateDropdownOptionsFromEntities(entities: Entity[] | undefined, onClick?: (value: string) => void): DropdownOption[] {
  const options: DropdownOption[] = [];

  entities?.forEach(entity => {
    if (!options.some(option => option.value === entity.slug)) {
      const option: DropdownOption = { label: entity.name, value: entity.slug! };
      if (!!onClick) option.onClick = () => onClick(entity.slug!);
      options.push(option);
    }
  });

  return options;
}
